export const addressesNames = {
  city: "Cidade",
  complement: "Complemento",
  district: "Bairro",
  number: "Número",
  state: "Estado",
  street: "Logradouro",
  zipCode: "CEP",
};
